// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".action-wrapper-attachment[data-v-22e787ea],.action-wrapper-email[data-v-22e787ea],.action-wrapper-text[data-v-22e787ea]{width:50%;padding:1vh}a[data-v-22e787ea]{cursor:pointer;color:purple}.action[data-v-22e787ea]{background:#e6e6e6;padding:1.2vh;border-left:6px solid;border-radius:1px;-webkit-box-shadow:0 3px 3px rgba(0,0,0,.3);box-shadow:0 3px 3px rgba(0,0,0,.3)}.action-person-name[data-v-22e787ea]{font-weight:700}", ""]);
// Exports
module.exports = exports;
